import React from 'react';
import { immediateAccess } from '../../data/content';
import { SectionCta } from '../SectionCta';
export function ImmediateAccess() {
  return <section className="bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-179" data-mp="yqh1a7q8ormt">
      <div className="mx-auto max-w-5xl" data-id="element-180" data-mp="upf1npseudkb">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-navy-800 sm:text-4xl" data-id="element-181" data-mp="usawv6cvio52">
          📲 You'll also get <em className="italic text-teal-600" data-id="element-182" data-mp="1mh4l9rdfj7pq">immediate access</em> to:
        </h2>

        <ul className="mt-9 grid gap-4 md:grid-cols-2" data-id="element-183" data-mp="1ifre9dyloyh8">
          {immediateAccess.map((item, index) => <li key={item.title} className={`flex gap-4 rounded-2xl border border-navy-100 bg-cream p-5 ${index === immediateAccess.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-184" data-mp="1dosw08u1xqbc" data-mpi={index}>
              <span aria-hidden="true" className="text-2xl leading-none" data-id="element-185" data-mp="26659fdchfdg1">
                {item.icon}
              </span>
              <div data-id="element-186" data-mp="21ck8pdji85d5">
                <h3 className="text-[16px] font-bold leading-snug text-navy-800 sm:text-[17px]" data-id="element-187" data-mp="wkplrk1g0t7z">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-[14px] leading-relaxed text-navy-700/80" data-id="element-188" data-mp="11ihe2f602hcp">{item.text}</p>
              </div>
            </li>)}
        </ul>

        <p className="mx-auto mt-9 max-w-2xl text-center text-[15px] leading-relaxed text-navy-700/85 sm:text-lg" data-id="element-189" data-mp="rtr34dszfj1k">
          Whatever GLP-1 patient walks into your practice, you'll have a clear map for organizing{' '}
          <strong className="font-bold text-navy-800" data-id="element-190" data-mp="itktj30en37o">
            what to review, what to verify, what to document, and what to prepare for follow-up.
          </strong>
        </p>

        <SectionCta label="Get full access to the system" data-id="element-191" data-mp="8uv8509av0mo" />
      </div>
    </section>;
}